// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Invoice from '@deere/cps-it.warranty-model-factory/lib/invoice';
import LabeledInput from '../../../shared/components/claim-fields/labeled-input';

function handleInvoiceNumberChange(value) {

    const trimmedValue = value.replace(/\s+/g, '');

    this.onInvoiceNumberChange(trimmedValue);

}

function handleCancelClick() {

    this.onCancelClick();

}

const ListItemForm = props =>
    <section className='list-item-form'>
        <div className='mass-invoice-row'>
            <LabeledInput
                className='invoice-number'
                isEditable={true}
                label='INVOICE_NUMBER'
                onChange={props::handleInvoiceNumberChange}
                value={props.invoice.massProcess.dealerInvoiceNumber ? props.invoice.massProcess.dealerInvoiceNumber.replace(/\s+/g, '') : ''}
            />
        </div>
        <footer className='button-group'>
            <button
                onClick={props::handleCancelClick}
            >
                <FormattedMessage id='CANCEL'/>
            </button>
            <button
                className='primary'
                disabled={!props.invoice.massProcess.dealerInvoiceNumber.length}
                onClick={props.onInvoiceSubmission}
            >
                <FormattedMessage id='SUBMIT'/>
            </button>
        </footer>
    </section>;

ListItemForm.displayName = 'ListItemForm';
ListItemForm.propTypes = {
    invoice: PropTypes.instanceOf(Invoice).isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onInvoiceNumberChange: PropTypes.func.isRequired,
    onInvoiceSubmission: PropTypes.func.isRequired
};

export default ListItemForm;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/mass-process-invoice/list-item-form.js